<template>
  <div class="h5-tabbar">
    <div class="tab-item" :class="{ active: active === 'home' }" @click="go('/home_h5', 'home')">
      <i class="el-icon-house"></i><span>首页</span>
    </div>
    <div class="tab-item" :class="{ active: active === 'meeting' }" @click="go('/meeting_h5', 'meeting')">
      <i class="el-icon-microphone"></i><span>录音识别</span>
    </div>
    <div class="tab-item" :class="{ active: active === 'document' }" @click="go('/document_h5', 'document')">
      <i class="el-icon-folder-opened"></i><span>文件管理</span>
    </div>
    <div class="tab-item" :class="{ active: active === 'person' }" @click="go('/person_h5', 'person')">
      <i class="el-icon-user"></i><span>我的</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "H5Tabbar",
  props: {
    active: { type: String, default: '' }
  },
  methods: {
    go(path, key) {
      if (this.active === key) return;
      this.$router.push(path);
    }
  }
}
</script>

<style scoped>
.h5-tabbar {
  height: 52px;
  background: #fff;
  border-top: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  z-index: 1000;
  flex-shrink: 0;
  padding-bottom: env(safe-area-inset-bottom);
}
.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  color: #909399;
  font-size: 11px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.tab-item i {
  font-size: 20px;
}
.tab-item.active {
  color: #409eff;
}
</style>
